import {Button, Divider, Grid} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import React, {useState} from 'react';
import {i18n2} from '../../../features/i18n/i18n';
import PopupRemove from 'components/Popups/PopupRemove';
import {UPDATE_NOTIFICATION} from 'features/navigation/actions';
import {useDispatch} from 'react-redux';
import {useAddCollaboratorInAttended} from '../hooks';
import {AddWith2ParamsOptions} from 'components/grid-dx/types';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: theme.spacing(0.5),
    marginRight: theme.spacing(1),
  },

  btnCancel: {
    color: '#8B0000',
    borderColor: '#8B0000',
    '&:hover': {
      backgroundColor: 'rgba(139, 0, 0, 0.1)',
      borderColor: '#600000',
    },
  },
  btnSelect: {
    fontWeight: 600,
    color: '#1C4257',
    borderColor: '#1C4257',
    backgroundColor: 'rgba(21, 101, 192, 0.1)',
    '&:hover': {
      backgroundColor: 'rgba(21, 101, 192, 0.25)',
      borderColor: '#0D47A1',
    },
    marginRight: theme.spacing(1),
  },
  btnDeselect: {
    fontWeight: 600,
    color: '#8B0000',
    borderColor: '#8B0000',
    backgroundColor: 'rgba(139, 0, 0, 0.1)',
    '&:hover': {
      backgroundColor: 'rgba(139, 0, 0, 0.25)',
      borderColor: '#600000',
    },
  },
  divider: {
    margin: `0 ${theme.spacing(1.5)}px`,
    height: theme.spacing(4),
  },
}));

interface ButtonsContainerProps {
  onSelectAll: () => void;
  onAddAllSAC: () => void;
  onDeselectAll: () => void;
  onCancel: () => void;
  redirect: boolean;
  setRedirect: (redirect: boolean) => void;
  addWith2ParamsOptions: AddWith2ParamsOptions;
}

const ButtonsContainer = ({
  onSelectAll,
  onAddAllSAC,
  onDeselectAll,
  onCancel,
  redirect,
  setRedirect,
  addWith2ParamsOptions,
}: ButtonsContainerProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openSignature, setOpenSignature] = useState<boolean>(false);
  const addCollaboInAttended = useAddCollaboratorInAttended();

  return (
    <Grid className={classes.container}>
      <Button
        variant="outlined"
        className={classes.btnSelect}
        style={{display: 'none'}}
        size="small"
        onClick={onAddAllSAC}>
        {i18n2._('Agregar todos')}
      </Button>
      <Button
        variant="outlined"
        className={classes.btnSelect}
        size="small"
        onClick={onSelectAll}>
        {i18n2._('Seleccionar todos')}
      </Button>
      <Button
        variant="outlined"
        className={classes.btnDeselect}
        size="small"
        onClick={onDeselectAll}>
        {i18n2._('Deseleccionar todos')}
      </Button>
      <Divider orientation="vertical" flexItem className={classes.divider} />
      <Button
        variant="contained"
        color="primary"
        onClick={() => setOpenSignature(true)}
        size="small"
        style={{marginRight: '8px'}}>
        {i18n2._('Confirmar')}
      </Button>
      <Button
        variant="outlined"
        className={classes.btnCancel}
        onClick={onCancel}
        size="small">
        {i18n2._('Cancelar')}
      </Button>
      {openSignature && (
        <PopupRemove
          open={openSignature}
          setOpen={setOpenSignature}
          promiseToReturn={addCollaboInAttended}
          types={addWith2ParamsOptions}
          url={'/Management'}
          redirect={redirect}
          setRedirect={setRedirect}
          dispatch={dispatch}
          actionType={UPDATE_NOTIFICATION}
          withMessage={false}
        />
      )}
    </Grid>
  );
};

export default ButtonsContainer;
